import { useEffect } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

import { LeagueEmbeddablePlaylist } from "./Components/LeagueEmbeddablePlaylist";
import { NextUpPlayer } from "./Components/NextUpPlayer";
import { PlaylistIdState } from "MVVM/State/embeddablePlaylist";
import { TrackedFirstHoverState } from "MVVM/State/iframe";
import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";
import { TRNPlaylist } from "./Components/TRNPlaylist";
import { HLTVEmbeddablePlaylist } from "./Components/HLTVEmbeddablePlaylist";

interface IEmbeddablePlaylistProps {
  playlist: string;
}

const EmbeddablePlaylist = ({ playlist }: IEmbeddablePlaylistProps) => {
  const searchParams = new URLSearchParams(window.location.search);
  const platform = searchParams.get("platform") || "";
  const layout = searchParams.get("layout") || "playlist";
  const theme = searchParams.get("theme") || "night";
  const [trackedFirstHover, setTrackedFirstHover] = useRecoilState(
    TrackedFirstHoverState,
  );
  const setPlaylistId = useSetRecoilState(PlaylistIdState);
  const { track } = useAnalyticsContext();

  useEffect(() => {
    if (!playlist) return;
    setPlaylistId(playlist);
  }, [playlist, setPlaylistId]);

  if (layout === "nextUp")
    return <NextUpPlayer playlist={playlist} platform={platform} />;

  const handleMouseEnter = () => {
    if (!trackedFirstHover) {
      track("Iframe First Hover", {
        locationIdentifier: "iframe_first_hover",
        location: "embeddable_playlist",
        platform,
      });
      setTrackedFirstHover(true);
    }
  };

  const platformMap: Record<string, string> = {
    TRACKERNETWORKLLC: "trn",
    UDOTGG: "lol",
    "U.GG": "lol",
    HLTV: "hltv",
    "HLTV.ORG": "hltv",
    "CROM, INC.": "hltv",
  };

  const playlistType = platformMap[platform];
  const themeable = ["hltv"];

  const components = {
    trn: TRNPlaylist,
    lol: LeagueEmbeddablePlaylist,
    hltv: HLTVEmbeddablePlaylist,
  } as const;

  const EmbeddablePlaylistComponent = playlistType
    ? components[playlistType as keyof typeof components]
    : null;

  if (!EmbeddablePlaylistComponent) return <></>;

  return (
    <EmbeddablePlaylistComponent
      platform={platform}
      playlist={playlist}
      handleMouseEnter={handleMouseEnter}
      theme={themeable.includes(playlistType) ? theme : undefined}
    />
  );
};

export default EmbeddablePlaylist;
